import { render } from "./add-service-company.vue?vue&type=template&id=41305fac&scoped=true"
import script from "./add-service-company.vue?vue&type=script&lang=js"
export * from "./add-service-company.vue?vue&type=script&lang=js"

import "./add-service-company.vue?vue&type=style&index=0&id=41305fac&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41305fac"]])

export default __exports__